import { gsap, Power3 } from "gsap";


export const preloaderClose = () => {
  let tl = gsap.timeline();


  tl.to(".preloader-counter", {
    duration: .5,
    opacity: 0,
    translateY: '-50px',
  }, 0)
  tl.to(".preloader-logo", {
    duration: .5,
    opacity: 0,
    translateY: '-100px',
  }, 0)
  tl.to(".preloader-background", {
    duration: 1,
    scaleX: 0,
    ease: Power3.easeOut,
    transformOrigin: "left"
  }, .5)

  tl.to(".preloader", {
    duration: 0,
    scaleX: 0,
    transformOrigin: "right"
  }, 2)

}